import styled from 'styled-components';

export const $InputContainer = styled.div`
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: ${props => props.theme.borderRadiusSM}px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;

  width: 100%;
`;
